import { CONTACT } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const InvestSection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section section-alt" id="investir" data-testid="invest-section">
      <div className="container" data-testid="invest-container">
        <div className="invest-grid" data-testid="invest-grid">
          <div className="invest-content" data-testid="invest-content">
            <p className="section-kicker" data-testid="invest-kicker">
              {copy.invest.kicker}
            </p>
            <h2 className="section-title" data-testid="invest-title">
              {copy.invest.title}
            </h2>
            <p className="section-text" data-testid="invest-text">
              {copy.invest.body}
            </p>
            <a className="primary-button" href={`mailto:${CONTACT.emailPrimary}`} data-testid="invest-cta">
              {copy.invest.cta}
            </a>
            <div className="invest-linkedin" data-testid="invest-linkedin">
              <h3 data-testid="invest-linkedin-title">{copy.invest.linkedinTitle}</h3>
              <p data-testid="invest-linkedin-body">{copy.invest.linkedinBody}</p>
              <a
                className="text-link"
                href={CONTACT.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="invest-linkedin-cta"
              >
                {copy.invest.linkedinCta}
              </a>
            </div>
          </div>
          <div className="invest-card" data-testid="invest-card">
            <h3 data-testid="invest-card-title">{copy.invest.impactTitle}</h3>
            <ul data-testid="invest-card-list">
              {copy.invest.impactItems.map((item, index) => (
                <li key={item} data-testid={`invest-card-item-${index + 1}`}>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestSection;